import { modals } from '@mantine/modals';
import { useDeleteTask } from 'api';
import type { Task } from 'api/models';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys, useTranslation } from 'locales';
import { TaskForm } from 'modules/Tasks/TaskForm';
import type React from 'react';
import AYSModal from 'shared/components/AYSModal';
import { Icon, IconName } from 'shared/components/Icon';
import { ButtonColor } from 'shared/io';
import { DialogShowId, DialogShowSize, dialogHide, showDialog } from 'store/view/view.actions';
import type { TableItemProps } from 'types/table';

type EnhancedTableTask = Task & {
  checked: boolean;
};

type TaskListItemActionsProps = TableItemProps<EnhancedTableTask> & {
  refetch: () => void;
};

export const TaskListItemActions = ({ item, refetch }: TaskListItemActionsProps) => {
  const { t } = useTranslation();
  const profile = useProfile();

  const { id } = item;
  const { mutate: deleteTaskMutation } = useDeleteTask();

  const updateTask = (e: React.MouseEvent) => {
    e.stopPropagation();
    modals.open({
      title: t(i18nKeys.FORM.TASK.EDIT),
      size: 'xl',
      children: <TaskForm taskId={String(id)} refetchTasks={refetch} />,
    });
  };

  const deleteTask = (e: React.MouseEvent) => {
    e.stopPropagation();
    showDialog({
      id: DialogShowId.CONFIRM,
      size: DialogShowSize.SMALL,
      title: t(i18nKeys.CONFIRM),
      keepMountOnExit: true,
      children: (
        <AYSModal
          text={t(i18nKeys.AYS.DELETE_TASK)}
          confirmButtonColor={ButtonColor.RED}
          confirmButtonText={t(i18nKeys.DELETE)}
          onConfirm={() =>
            deleteTaskMutation(
              { id },
              {
                onSuccess: () => {
                  dialogHide(DialogShowId.CONFIRM);
                  refetch();
                },
              },
            )
          }
        />
      ),
    });
  };

  return (
    <>
      <Icon onClick={updateTask} name={IconName.SETTINGS_GEAR} size="18px" />
      {profile.isAdmin && <Icon onClick={deleteTask} name={IconName.TRASH_SIMPLE} size="18px" />}
    </>
  );
};
